import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5rem;
  width: 100%;
  height: 100vh;
`;
